import React from "react";
import { useMediaQuery } from "react-responsive";
import { QuestionTitle } from "../../components/QuestionTitle";
import { Flex, Info, Info3 } from "../../styles/common";
import { theme } from "../../styles/theme";

export const DownloadReportsVendor = () => {
  const isMobile = useMediaQuery({
    query: `(max-width: ${theme.breakpoints.sm})`,
  });

  return (
    <Flex direction="column">
      <QuestionTitle />
      <img
        alt="como_descargar_informes"
        src="https://6957948.fs1.hubspotusercontent-na1.net/hubfs/6957948/como_descargar_informes.jpg"
        width={isMobile ? "100%" : "688px"}
      />
      <ul>
        <li>
          <Info>
            Ingresa a
            <a
              style={{ color: theme.colors.secondary }}
              href="http://bimbau.co/"
              rel="noopener"
            >
              <em>
                <strong>&nbsp;bimbau.co</strong>
              </em>
            </a>
            &nbsp;con<strong>&nbsp;Usuario</strong>&nbsp;y
            <strong>&nbsp;Contraseña.</strong>
          </Info>
        </li>
        <li>
          <Info>
            Ve a
            <em>
              <strong> Informes </strong>
            </em>
            que encuentras en la barra superior.
          </Info>
        </li>
        <li>
          <Info>
            Selecciona el tipo de <strong>Informe</strong> que necesites
            descargar.<br></br>
            <br></br>
            &nbsp;📍Ten presente que puedes descargar informes de{" "}
            <strong>Órdenes de compra, Negociaciones</strong> y{" "}
            <strong>Productos.</strong>
          </Info>
        </li>
        <li>
          <Info>
            Establece un rango de periodicidad para descargar el informe.&nbsp;
            <br></br>
            <br></br>
            📍Puedes descargarlo por mes o personalizar las fechas.
          </Info>
        </li>
        <li>
          <Info>
            Para finalizar, haz clic en <strong>Descarga</strong> y listo
            <br></br>
            <br></br>Automáticamente se descargará un archivo con el
            informe.&nbsp;<br></br>
            <br></br>
            <br></br>
            <strong>⚠️NOTA&nbsp;</strong>
            <Info3 style={{ textDecoration: "none" }}>
              <strong>IMPORTANTE</strong>⚠️
            </Info3>
            &nbsp;Los informes de{" "}
            <strong>Negociaciones y Órdenes de compra</strong> pueden ser
            descargados por los <strong>Administradores de la cuenta. </strong>
            También pueden hacerlo, en el caso de{" "}
            <strong>Negociaciones </strong>
            aquellas personas encargadas o responsable de la Negociación, y en
            el caso de <strong>Órdenes de compra</strong>, el usuario que
            solicito los insumos.
          </Info>
        </li>
      </ul>
    </Flex>
  );
};
